export const CONST_ACCESS_TOKEN = "access_token";
export const CONST_REFRESH_TOKEN = "refresh_token";

export function getToken(type: string) {
    return localStorage.getItem(type);
  }
